import plusIcon from "../assets/svg/plus-table.svg";
import {
    apiDeleteRemittances,
    apiGetRemittances,
    apiGetRemittancesExcel,
    apiGetSingleRemittanceExcel
} from "../api/remittanceApi";
import { apiGetWarehouses } from "../api/warehouseApi";
import { apiGetBranches } from "../api/branchApi";
import { apiGetProjects } from "../api/projectApi";
import { openFactorDrawer, openRemittanceDrawer } from "../helpers/DrawerActions";
import { apiPersonsList } from "../api/personApi";
import { updateFactor, updateRemittance } from "../store/actions/formAction";

const defaultTableColumns = [
    {
        name: "کد حسابداری",
        key: "accountingCode",
        filterParams: {
            column: "accountingCode",
            columnType: "string",
        },
    },
    {
        name: "تاریخ",
        key: "date",
        filterParams: {
            column: "date",
            columnType: "date",
        },
        searchType: "date",
    },
    {
        name: "انبار",
        key: "Warehouse",
        getValue: (remittance) => remittance.Warehouse?.title,
        filterParams: {
            column: "WarehouseId",
            columnType: "string",
            relationModelName: "Warehouse",
            relationColumn: "title",
        },
        searchType: "autocomplete",
        dataKey: {
            column: "inventories",
            key: "title",
        },
    },
    {
        name: "نوع فاکتور",
        key: "factor_type",
        filterParams: {
            column: "factor_id",
            columnType: "string",
            relationModelName: "Factor",
            relationColumn: "type",
        },
        disableSearch: true,
        getValue: (remittance) => {
            switch (remittance.factor?.type) {
                case "buy":
                    return "خرید";
                case "buyReturn":
                    return "برگشت از خرید";
                case "sale":
                    return "فروش";
                case "saleReturn":
                    return "برگشت از فروش";
                case "waste":
                    return "ضایعات";
            }
        },
        searchType: "status",
        dataKey: [
            { label: "فروش", value: "sale", id: 1 },
            { label: "خرید", value: "buy", id: 2 },
            { label: "برگشت از فروش", value: "saleReturn", id: 3 },
            { label: "برگشت از خرید", value: "buyReturn", id: 4 },
            { label: "ضایعات", value: "waste", id: 5 },
        ],
    },
    {
        name: "شرح",
        key: "description",
        filterParams: {
            column: "description",
            columnType: "string",
        },
        clickable: () => true,
        onClick: (dispatch, item) => {
            openRemittanceDrawer(dispatch, item);
        },
    },
    {
        name: "فاکتور",
        key: "factor",
        getValue: (remittance) => remittance.factor?.title,
        filterParams: {
            column: "factor_id",
            columnType: "string",
            relationModelName: "Factor",
            relationColumn: "title",
        },
        clickable: (item) => item.factor,
        onClick: (dispatch, item) => {
            openFactorDrawer(dispatch, item.factor);
        },
    },
    {
        name: "پروژه",
        key: "Project",
        getValue: (remittance) => remittance.Project?.title,
        filterParams: {
            column: "ProjectId",
            columnType: "string",
            relationModelName: "Project",
            relationColumn: "title",
        },
        searchType: "autocomplete",
        dataKey: {
            column: "projects",
            key: "title",
        },
    },
    {
        name: "شعبه",
        key: "Branch",
        getValue: (remittance) => remittance.Branch?.title,
        filterParams: {
            column: "BranchId",
            columnType: "string",
            relationModelName: "Branch",
            relationColumn: "title",
        },
        searchType: "autocomplete",
        dataKey: {
            column: "branches",
            key: "title",
        },
    },
];

export const remittanceIndexData = [
    {
        title: "حواله (خروج)",
        description: "",
        key: "exit",
        label: "حواله",
        pluralLabel: "حواله های",
        pageTitle: "حواله های انبار",
        pageDescription: "لیست حواله های خروجی انبار",
        tableColumns: defaultTableColumns,
        disableDateFilter: true,
        actions: {
            view: {
                label: "مشاهده حواله",
                openDrawer: openRemittanceDrawer,
            },
            add: {
                title: "ثبت حواله",
                icon: plusIcon,
                url: "/remittance/add",
            },
            singleExcel: {
                title: "خروجی اکسل",
                icon: plusIcon,
                export: apiGetSingleRemittanceExcel
            },
            edit: {},
            fetch: apiGetRemittances,
            delete: apiDeleteRemittances,
            copy: true,
            printRemittance: true,
            showSingleExcel: true,
            excel: {
                export: apiGetRemittancesExcel,
            },
            sort: {
                model: "Bill",
            },
            archive: {
                model: 'bill'
            }
        },
    },
    {
        title: "رسید (ورود)",
        description: "",
        key: "enter",
        label: "رسید",
        pluralLabel: "رسیدهای",
        pageTitle: "رسیدهای انبار",
        pageDescription: "لیست رسیدهای ورودی انبار",
        tableColumns: defaultTableColumns,
        disableDateFilter: true,
        actions: {
            view: {
                label: "مشاهده رسید",
                openDrawer: openRemittanceDrawer,
            },
            add: {
                title: "ثبت رسید/حواله",
                icon: plusIcon,
                url: "/remittance/add",
            },
            singleExcel: {
                title: "خروجی اکسل",
                icon: plusIcon,
                export: apiGetSingleRemittanceExcel
            },
            edit: {},
            fetch: apiGetRemittances,
            delete: apiDeleteRemittances,
            copy: true,
            printRemittance: true,
            showSingleExcel: true,
            excel: {
                export: apiGetRemittancesExcel,
            },
            sort: {
                model: "Bill",
            },
            archive: {
                model: 'remittance'
            }
        },
    },
    // {
    //   title: "انتقال",
    //   description: "",
    //   key: "transfer",
    //   label: "حواله",
    //   pluralLabel: "حواله های",
    //   pageTitle: "حواله های انبار",
    //   pageDescription: "لیست حواله های انتقال بین انبارها",
    //   tableColumns: defaultTableColumns,
    //   disableDateFilter: true,
    //   actions: {
    //     view: {
    //       label: "مشاهده حواله",
    //       openDrawer: openRemittanceDrawer,
    //     },
    //     add: {
    //       title: "ثبت حواله",
    //       icon: plusIcon,
    //       url: "/remittance/add",
    //     },
    //     fetch: apiGetRemittances,
    //     delete: apiDeleteRemittances,
    //     copy: true,
    //     excel: {
    //       export: apiGetRemittancesExcel,
    //     },
    //     sort: {
    //       model: "Bill",
    //     },
    //   },
    // },
];

export const remittanceFormData = {
    remittance: {
        title: "سند",
        navigation: {
            title: "ثبت سند",
            // description: 'ثبت اطلاعات شخص',
            backTitle: "بازگشت",
            backUrl: "/remittance",
        },
        tabs: [
            {
                key: "enter",
                name: "ورود",
                // factorTypes: '["buy", "saleReturn", "waste"]',
                factorTypes: '["buy", "waste"]',
                inputs: [
                    {
                        formType: "remittance",
                        outerWrapperClass:
                            "col-lg-8 col-md-8 col-sm-8 col-xs-8 style-fields-right style-fields-left style-fields-top",
                        type: "selectBox",
                        addModal: {
                            props: {
                                component: "inventory",
                                title: "افزودن انبار",
                                closeButton: true,
                                onFinish: (token) => apiGetWarehouses(token, null, "allWarehouse"),
                            },
                        },
                        name: "Warehouse",
                        label: "انبار",
                        showInput: true,
                        required: true,
                        options: "inventories",
                        refreshList: (token) => apiGetWarehouses(token, null, "allWarehouse")
                    },
                    {
                        formType: "remittance",
                        outerWrapperClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4 style-fields-right style-fields-left",
                        wrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 px-1 style-padding-inputs",
                        active: true,
                        type: "accountingCode",
                        name: "accountingCode",
                        label: "کد حسابداری",
                        maxLength: 20,
                        options: [
                            {
                                label: "اتوماتیک",
                                value: true,
                            },
                            {
                                label: "دستی",
                                value: false,
                            },
                        ],
                    },
                    {
                        formType: "remittance",
                        outerWrapperClass:
                            "col-lg-4 col-md-4 col-sm-4 col-xs-4 style-fields-left style-fields-right style-fields-top",
                        type: "selectBox",
                        addModal: {
                            props: {
                                component: "branch",
                                title: "افزودن شعبه",
                                closeButton: true,
                                onFinish: (token) => apiGetBranches(token),
                            },
                        },
                        name: "Branch",
                        label: "شعبه",
                        showInput: true,
                        options: "branches",
                    },
                    {
                        formType: "remittance",
                        outerWrapperClass:
                            "col-lg-4 col-md-4 col-sm-4 col-xs-4 style-fields-left style-fields-right style-fields-top",
                        type: "selectBox",
                        addModal: {
                            props: {
                                component: "project",
                                title: "افزودن پروژه",
                                closeButton: true,
                                onFinish: (token) => apiGetProjects(token),
                            },
                        },
                        name: "Project",
                        label: "پروژه",
                        showInput: true,
                        options: "projects",
                    },
                    {
                        formType: "remittance",
                        outerWrapperClass:
                            "col-lg-4 col-md-4 col-sm-4 col-xs-4 style-fields-left style-fields-right style-fields-top",
                        type: "datePickerInput",
                        name: "date",
                        label: "تاریخ",
                    },
                    {
                        formType: "remittance",
                        outerWrapperClass:
                            "col-lg-12 col-md-12 col-sm-12 col-xs-12 style-fields-right style-fields-left style-fields-top",
                        name: "description",
                        type: "optionalDescription",
                        label: "توضیحات",
                        maxLength: 64,
                        active: true,
                    },
                    {
                        formType: "remittance",
                        outerWrapperClass:
                            "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top",
                        name: "transport",
                        label: "حمل و نقل",
                        maxLength: 64,
                    },
                    {
                        formType: "remittance",
                        outerWrapperClass:
                            "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top",
                        name: "delivery",
                        label: " نام تحویل گیرنده",
                        maxLength: 64,
                    },
                    {
                        formType: "remittance",
                        outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top",
                        type: "selectBox",
                        addModal: {
                            props: {
                                component: "person",
                                title: "افزودن شخص",
                                closeButton: true,
                                onFinish: (token) => apiPersonsList(token, "customer"),
                            },
                        },
                        name: "person",
                        label: "تحویل دهنده",
                        showInput: true,
                        options: "customers",
                        onChange: (dispatch, value) => {
                            dispatch(updateRemittance("delivery", value.nickName));
                        },
                    },
                ],
            },
            {
                key: "exit",
                name: "خروج",
                // factorTypes: '["sale", "buyReturn", "waste"]',
                factorTypes: '["sale", "waste"]',
                inputs: [
                    {
                        formType: "remittance",
                        outerWrapperClass:
                            "col-lg-8 col-md-8 col-sm-8 col-xs-8 style-fields-right style-fields-left style-fields-top",
                        type: "selectBox",
                        addModal: {
                            props: {
                                component: "inventory",
                                title: "افزودن انبار",
                                closeButton: true,
                                onFinish: (token) => apiGetWarehouses(token, null, "allWarehouse"),
                            },
                        },
                        name: "Warehouse",
                        label: "انبار",
                        showInput: true,
                        required: true,
                        options: "inventories",
                    },
                    {
                        formType: "remittance",
                        outerWrapperClass:
                            "col-lg-4 col-md-4 col-sm-4 col-xs-4 style-fields-left style-fields-right style-fields-top",
                        wrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 px-1 style-padding-inputs",
                        active: true,
                        type: "accountingCode",
                        name: "accountingCode",
                        label: "کد حسابداری",
                        maxLength: 20,
                        options: [
                            {
                                label: "اتوماتیک",
                                value: true,
                            },
                            {
                                label: "دستی",
                                value: false,
                            },
                        ],
                    },
                    {
                        formType: "remittance",
                        outerWrapperClass:
                            "col-lg-4 col-md-4 col-sm-4 col-xs-4 style-fields-left style-fields-right style-fields-top",
                        type: "selectBox",
                        addModal: {
                            props: {
                                component: "branch",
                                title: "افزودن شعبه",
                                closeButton: true,
                                onFinish: (token) => apiGetBranches(token),
                            },
                        },
                        name: "Branch",
                        label: "شعبه",
                        showInput: true,
                        options: "branches",
                    },
                    {
                        formType: "remittance",
                        outerWrapperClass:
                            "col-lg-4 col-md-4 col-sm-4 col-xs-4 style-fields-left style-fields-right style-fields-top",
                        type: "selectBox",
                        addModal: {
                            props: {
                                component: "project",
                                title: "افزودن پروژه",
                                closeButton: true,
                                onFinish: (token) => apiGetProjects(token),
                            },
                        },
                        name: "Project",
                        label: "پروژه",
                        showInput: true,
                        options: "projects",
                    },
                    {
                        formType: "remittance",
                        outerWrapperClass:
                            "col-lg-4 col-md-4 col-sm-4 col-xs-4 style-fields-left style-fields-right style-fields-top",
                        type: "datePickerInput",
                        name: "date",
                        label: "تاریخ",
                    },
                    {
                        formType: "remittance",
                        outerWrapperClass:
                            "col-lg-12 col-md-12 col-sm-12 col-xs-12 style-fields-right style-fields-left style-fields-top",
                        name: "description",
                        type: "optionalDescription",
                        label: "توضیحات",
                        maxLength: 64,
                        active: true,
                    },
                    {
                        formType: "remittance",
                        outerWrapperClass:
                            "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top",
                        name: "transport",
                        label: "حمل و نقل",
                        maxLength: 64,
                    },
                    {
                        formType: "remittance",
                        outerWrapperClass:
                            "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top",
                        name: "delivery",
                        label: "نام تحویل گیرنده",
                        maxLength: 64,
                    },
                    {
                        formType: "remittance",
                        outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top",
                        type: "selectBox",
                        addModal: {
                            props: {
                                component: "person",
                                title: "افزودن شخص",
                                closeButton: true,
                                onFinish: (token) => apiPersonsList(token, "customer"),
                            },
                        },
                        name: "person",
                        label: "تحویل گیرنده",
                        showInput: true,
                        options: "customers",
                        onChange: (dispatch, value) => {
                            dispatch(updateRemittance("delivery", value.nickName));
                        },
                    },
                ],
            },
            {
                key: "transfer",
                name: "انتقال",
                inputs: [
                    {
                        formType: "remittance",
                        outerWrapperClass:
                            "col-lg-4 col-md-4 col-sm-4 col-xs-4 style-fields-left style-fields-right style-fields-top",
                        type: "selectBox",
                        addModal: {
                            props: {
                                component: "inventory",
                                title: "افزودن انبار",
                                closeButton: true,
                                onFinish: (token) => apiGetWarehouses(token, null, "allWarehouse"),
                            },
                        },
                        name: "Warehouse",
                        label: "انبار مبدا",
                        showInput: true,
                        required: true,
                        options: "inventories",
                    },
                    {
                        formType: "remittance",
                        outerWrapperClass:
                            "col-lg-4 col-md-4 col-sm-4 col-xs-4 style-fields-left style-fields-right style-fields-top",
                        type: "selectBox",
                        addModal: {
                            props: {
                                component: "inventory",
                                title: "افزودن انبار",
                                closeButton: true,
                                onFinish: (token) => apiGetWarehouses(token, null, "allWarehouse"),
                            },
                        },
                        name: "TargetWarehouse",
                        label: "انبار مقصد",
                        showInput: true,
                        required: true,
                        options: "inventories",
                    },
                    {
                        formType: "remittance",
                        outerWrapperClass:
                            "col-lg-4 col-md-4 col-sm-4 col-xs-4 style-fields-left style-fields-right style-fields-top",
                        wrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 px-1 style-padding-inputs",
                        active: true,
                        type: "accountingCode",
                        name: "accountingCode",
                        label: "کد حسابداری",
                        maxLength: 20,
                        options: [
                            {
                                label: "اتوماتیک",
                                value: true,
                            },
                            {
                                label: "دستی",
                                value: false,
                            },
                        ],
                    },
                    {
                        formType: "remittance",
                        outerWrapperClass:
                            "col-lg-4 col-md-4 col-sm-4 col-xs-4 style-fields-left style-fields-right style-fields-top",
                        type: "selectBox",
                        addModal: {
                            props: {
                                component: "branch",
                                title: "افزودن شعبه",
                                closeButton: true,
                                onFinish: (token) => apiGetBranches(token),
                            },
                        },
                        name: "Branch",
                        label: "شعبه",
                        showInput: true,
                        options: "branches",
                    },
                    {
                        formType: "remittance",
                        outerWrapperClass:
                            "col-lg-4 col-md-4 col-sm-4 col-xs-4 style-fields-left style-fields-right style-fields-top",
                        type: "selectBox",
                        addModal: {
                            props: {
                                component: "project",
                                title: "افزودن پروژه",
                                closeButton: true,
                                onFinish: (token) => apiGetProjects(token),
                            },
                        },
                        name: "Project",
                        label: "پروژه",
                        showInput: true,
                        options: "projects",
                    },
                    {
                        formType: "remittance",
                        outerWrapperClass:
                            "col-lg-4 col-md-4 col-sm-4 col-xs-4 style-fields-left style-fields-right style-fields-top",
                        type: "datePickerInput",
                        name: "date",
                        label: "تاریخ",
                    },
                    {
                        formType: "remittance",
                        outerWrapperClass:
                            "col-lg-12 col-md-12 col-sm-12 col-xs-12 style-fields-right style-fields-left style-fields-top",
                        name: "description",
                        type: "optionalDescription",
                        label: "توضیحات",
                        maxLength: 64,
                        active: true,
                    },
                    {
                        formType: "remittance",
                        outerWrapperClass:
                            "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top",
                        name: "transport",
                        label: "حمل و نقل",
                        maxLength: 64,
                    },
                    {
                        formType: "remittance",
                        outerWrapperClass:
                            "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top",
                        name: "delivery",
                        label: "نام تحویل گیرنده",
                        maxLength: 64,
                    },
                    {
                        formType: "remittance",
                        outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left style-fields-top",
                        type: "selectBox",
                        addModal: {
                            props: {
                                component: "person",
                                title: "افزودن شخص",
                                closeButton: true,
                                onFinish: (token) => apiPersonsList(token, "customer"),
                            },
                        },
                        name: "person",
                        label: "تحویل گیرنده",
                        showInput: true,
                        options: "customers",
                        onChange: (dispatch, value) => {
                            dispatch(updateRemittance("delivery", value.nickName));
                        },
                    },
                ],
            },
        ],
    },
};
